import { RenderInjector } from './RenderInjector';

export const RenderInjectionModule = {
  __init__: ['renderInjector'],
  renderInjector: ['type', RenderInjector],
};
